// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface HeadingWrapperProps {
    hide?: boolean;
}

export interface HeadingWrapperStyles {
    wrapper?: InjectableCss;
    content?: InjectableCss;
}

export const headingWrapperStyles: HeadingWrapperStyles = {
    wrapper: {
        css: css`
            padding: ${pxToRem(20)} 0;
            min-height: 145px;
            background-color: ${getColor("common.accent")};
            display: flex;
            align-items: center;
            justify-content: left;
            border-bottom: 1px solid ${getColor("common.border")};

            ${breakpoint("sm")} {
                padding: ${pxToRem(30)} 0;
                min-height: 172px;
            }
        `,
    },
    content: {
        css: css`
            ${siteWidthStyles()}
            width: 100%;
        `,
    },
};

const styles = headingWrapperStyles;

const HeadingWrapper: FC<HeadingWrapperProps> = ({ hide, children }) => {
    if (hide) {
        return <>{children}</>;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.content}>{children}</StyledWrapper>
        </StyledWrapper>
    );
};

export default HeadingWrapper;
